import React from 'react';
import { AggregateError, UserReadableError } from '../Functions/Error';

export function useCVStepFunctions({
    formData,
    setFormData,
    setLoading,
    uploadFileToCV,
    processCVChanges,
    processCVSkillAchievementChanges,
    originalCVKSA
}) {
    const setCVBytes = React.useCallback((bytes) => {
        setFormData(oFD => {
            return {
                ...oFD,
                cvDOCX: bytes
            };
        });
    }, [setFormData]);


    const processCVSkillAchievements = React.useCallback((cvId, keySkillsAchievements) => {
         const ksaChanges = keySkillsAchievements.map(ksa => ({...ksa, _mcb_cv_value: cvId }));
        originalCVKSA.forEach(ksa => {
            if (!keySkillsAchievements.some(oksa => oksa.mcb_cvkeyskillachievementid === ksa.mcb_cvkeyskillachievementid)) {
                ksaChanges.push({
                    ...ksa,
                    deleted: true
                });
            } 
        });
        return processCVSkillAchievementChanges(ksaChanges);
    }, [processCVSkillAchievementChanges, originalCVKSA]);

    const updateCV = React.useCallback(async (preFormChange) => {
        const formCV = (formData || {})?.cv || {};
        const cvDocx = (formData || {})?.cvDOCX;
        if (!cvDocx) throw UserReadableError(`Please Generate a CV by Selecting the CV Template on the Right Side of the Page`);
        const keySkillsAchievements = formCV?.keySkillsAchievements || [];
        setLoading(true);
        try {

            formCV.mcb_CVRoles = (formCV.cvRoles || []).map(mcb_roleid => ({ mcb_roleid }));
            formCV.mcb_CVABC = (formCV.achievements || []).map((mcb_abcid) => ({ mcb_abcid }));

            formCV.mcb_CVKeySkill = Array.isArray(formCV.skills) ? formCV.skills.map((mcb_skillid) => ({ mcb_skillid })) : [];
            formCV.mcb_cliftonstrength = (formCV.cliftonstrengths || []).join(",") || null;
            formCV.mcb_CVQualifications = Array.isArray(formCV.qualifications) ? formCV.qualifications.map((mcb_qualificationid) => ({ mcb_qualificationid })) : [];
            const cvName = formCV.mcb_cvname || ["CV", formCV.mcb_roletitle, formCV.mcb_rolecompanyname].filter(a => a).join(" ");
            formCV.mcb_cvname = cvName;

            const changes = [formCV];
            if (typeof preFormChange === "function") {
                await preFormChange(changes);
            }
            const cvData = await ((await processCVChanges(changes))[0]);
            const cvId = cvData?.mcb_cvid;
            const promises = [];
            if (cvDocx && cvId) {
                promises.push(uploadFileToCV(cvId, "mcb_cvdocument", cvDocx, (cvName || "CV") + ".docx"));
            } else {
                throw UserReadableError(`Please wait for CV to Generate.`);
            }
            if (cvId) {
                promises.push(processCVSkillAchievements(cvId, keySkillsAchievements));
            }
            await Promise.all(promises);
            return cvId;
        } catch (error) {
            const err = AggregateError([error], "Failed to update CV");
            err.UserReadableError = true;
            throw err;
        } finally {
            setLoading(false);
        }
    }, [formData, processCVChanges, uploadFileToCV, processCVSkillAchievements, setLoading]);


    return { setCVBytes, updateCV };
}
